import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Home/HomeFAQ";
const I18n = I18nUtil.createScoped(Translations);
export const getHomeFAQ = (type: "crypto" | "stock") => {
  const FAQMap = {
    crypto: [
      {
        question: I18n.t("What is Edgen AI Search?"),
        answer: I18n.t(
          "Edgen AI Search is a smart tool designed to help you understand and trade cryptocurrencies better. It acts like a helpful friend who knows a lot about the crypto market. With Edgen, you can find out more about different tokens, see why their prices are changing, and decide if it's a good time to buy.",
        ),
      },
      {
        question: I18n.t("How can I use Edgen to understand token prices?"),
        answer: I18n.t(
          "You can learn about token prices using Edgen by simply searching for the token you're curious about. Edgen provides insights into why the prices are going up or down. This information can help you understand the market and make better decisions when trading.",
        ),
      },
      {
        question: I18n.t("Is Edgen suitable for beginners in crypto trading?"),
        answer: I18n.t(
          "Yes! Edgen is designed to be user-friendly, making it great for beginners. It gives clear explanations and simplifies complex information so that everyone, regardless of age or experience, can understand and benefit from crypto trading.",
        ),
      },
      {
        question: I18n.t(
          "How does Edgen predict if token prices will increase or decrease?",
        ),
        answer: I18n.t(
          "Edgen uses smart technology to analyze market trends and data. By looking at various factors, it can give you a prediction on whether the price of a specific token is likely to go up or down, helping you make informed choices.",
        ),
      },
      {
        question: I18n.t("What does the Macro Decoder feature do?"),
        answer: I18n.t(
          "The Macro Decoder feature helps you understand broader trends that can affect cryptocurrency prices. It looks beyond just one token and gives you insights from the entire market, which helps you make smarter trading decisions.",
        ),
      },
      {
        question: I18n.t("What is the purpose of the Discover Ecosystems ?"),
        answer: I18n.t(
          "The Discover Ecosystems feature provides information about how different cryptocurrencies interact with each other within their networks. This knowledge helps you see the bigger picture and understand market dynamics better.",
        ),
      },
      {
        question: I18n.t("What is 'Crypto Insight'?"),
        answer: I18n.t(
          "Crypto Insight refers to the popularity and attention a token is getting in the market. Edgen helps you track which tokens are trending or gaining interest, so you can make decisions based on what others are talking about.",
        ),
      },
      {
        question: I18n.t("How do I get started with Edgen?"),
        answer: I18n.t(
          "Getting started with Edgen is easy! Just go on our website edgen.tech, explore the features, and start using the AI tools to enhance your trading journey. Whether you are a novice or an experienced trader, Edgen has something for everyone.",
        ),
      },
    ],
    stock: [
      {
        question: I18n.t("What is Edgen?"),
        answer: I18n.t(
          "Edgen is an AI co-pliot for stocks and crypto investors. Our core feature Edgen Stock Pro™️ and Edgen Crypto Pro™️ are powerful AI copilots that provides real-time bullish calls, market signals, trading alerts, crypto analytics, stock insights, investing ideas, 360 report and powerful portfolio analysis.",
        ),
      },
      {
        question: I18n.t(
          "How is Edgen different from other AI Investment tools?",
        ),
        answer: I18n.t(
          "Edgen stands out because it mixes different kinds of information—like pivot alert and hard market facts—using advanced AI. This helps provide clearer insights. Our system encourages community involvement and rewards users for sharing their knowledge, which you won't find in most other platforms. Essentially, we make it easier to understand stock and cryptocurrency by combining various insights, which helps both new and experienced traders.",
        ),
      },
      {
        question: I18n.t("How does Edgen help me trade better than big firms?"),
        answer: I18n.t(
          "Edgen gives you a quick way to see important trends in the stock and crypto market. It gathers data from many places, like market performance, earning, exchanges and charts, faster than you can do by hand. Our tools let you spot new trends early, which can give you an edge when trading. It's designed to provide collective knowledge that helps you compete with larger firms.",
        ),
      },
      {
        question: I18n.t("How does Edgen predict prices?"),
        answer: I18n.t(
          "We predict cryptocurrency prices using AI that learns from technical indicators, market sentiments, business news and macro economy to deliver timely trading insights",
        ),
      },
      {
        question: I18n.t("Can anyone use Edgen?"),
        answer: I18n.t(
          "Absolutely! Edgen is designed for everyone, whether you're brand new to stock and cryptocurrency or have been trading for years. The platform offers simple and easy-to-understand insights, making it accessible for all ages and experience levels.",
        ),
      },
      {
        question: I18n.t("What features does Edgen offer?"),
        answer: I18n.t(
          "Use Edgen's tools for real-time bullish calls, market signals, trading alerts, crypto analytics, stock insights, investing ideas, and powerful portfolio analysis.",
        ),
      },
      {
        question: I18n.t("Is there a mobile app for Edgen?"),
        answer: I18n.t(
          "Currently, Edgen is primarily a web-based platform, but you can access it easily from your smartphone's browser. Our team is working on mobile app features to enhance your trading experience on the go. Stay tuned!",
        ),
      },
      {
        question: I18n.t("How do I start using Edgen?"),
        answer: I18n.t(
          "To start using Edgen, simply visit our website and sign up for a free trial. This will give you access to our smart trading tools and insights, allowing you to explore the platform before deciding to continue. Your journey into trading begins here!",
        ),
      },
      {
        question: I18n.t("How can I get support if I have questions?"),
        answer: I18n.t(
          "If you have any questions or need assistance, Edgen offers customer support through various channels like email and social media. Feel free to reach out us on X (https://x.com/EdgenTech) and Discord (https://discord.com/invite/edgentech), and our team will be happy to help you with anything you need.",
        ),
      },
    ],
  };
  return FAQMap[type];
};
